(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mh-purchase-context"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function (event) {
    var copy = event.target.closest('[data-mh-copy-code]');
    if (copy) {
      var copied = false;
      try {
        await navigator.clipboard.writeText(copy.dataset.mhCopyCode);
        copied = true;
      } catch (error) {
        var input = document.createElement('textarea');
        input.value = copy.dataset.mhCopyCode;
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        copied = document.execCommand('copy');
        input.remove();
      }
      var label = copy.querySelector('.mh-purchase-context__copy-label');
      if (!copied) {
        var code = copy.querySelector('.mh-purchase-context__code');
        if (code) {
          var selection = window.getSelection();
          var range = document.createRange();
          range.selectNodeContents(code);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
      if (label) {
        label.textContent = copied ? 'Copied' : 'Select code';
      }
    }
    var help = event.target.closest('[data-mh-purchase-help]');
    if (help) {
      var contact = document.querySelector(
        '[data-merowen-pillow-product-section-type="contact"], [data-merowen-tapestry-product-section-type="contact"], [data-merowen-macrame-product-section="contact"]'
      );
      if (contact) contact.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
